module.exports = __webpack_public_path__ + "static/media/arrow_right.e48cccc0.svg";